import { observer } from "mobx-react-lite";
import { MDSLink } from "@/mds";
import styled from "@emotion/styled";
import { IEmailSenderStore } from "@/store/email-senders/types";

type TProps = {
  isError?: boolean;
  integrationStore: IEmailSenderStore;
};

export const IntegrationsContentResend = observer<TProps>(({ isError, integrationStore }) => {
  const { unVerifiedItem, requestNewVerificationCode } = integrationStore;

  if (!unVerifiedItem) {
    return null;
  }

  return (
    <StyledLink
      isError={isError}
      onPress={() => {
        requestNewVerificationCode(unVerifiedItem.id);
      }}
    >
      Resend code
    </StyledLink>
  );
});

const StyledLink = styled(MDSLink)<{ isError?: boolean }>(({ theme, isError }) => ({
  color: isError ? theme.colors.text.danger : theme.colors.text.secondary,
}));
